import React from 'react';

export const BookmarkGray400Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33334 4.16699C3.33334 3.50395 3.59673 2.86807 4.06557 2.39923C4.53441 1.93038 5.17029 1.66699 5.83334 1.66699H14.1667C14.8297 1.66699 15.4656 1.93038 15.9344 2.39923C16.4033 2.86807 16.6667 3.50395 16.6667 4.16699V17.5237C16.6667 18.5403 15.5167 19.132 14.69 18.5412L10 15.1912L5.31 18.5412C4.4825 19.1328 3.33334 18.5412 3.33334 17.5245V4.16699ZM5.83334 3.33366C5.61232 3.33366 5.40036 3.42146 5.24408 3.57774C5.0878 3.73402 5 3.94598 5 4.16699V16.7145L9.27334 13.662C9.48536 13.5105 9.73942 13.4291 10 13.4291C10.2606 13.4291 10.5146 13.5105 10.7267 13.662L15 16.7145V4.16699C15 3.94598 14.9122 3.73402 14.7559 3.57774C14.5996 3.42146 14.3877 3.33366 14.1667 3.33366H5.83334Z"
        fill="#888888"
      />
    </svg>
  );
};
